<template>
  <PageSlider></PageSlider>

  <!--=== nossas linhas ==========-->
  <div v-if="listaProdutos != '' && listaProdutos.length > 0" class="services-area1">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-sm-11">
          <!-- Section Tittle -->
          <div class="section-tittle text-center mb-60 mt-20">
            <h2>Produtos em Destaque</h2>
          </div>
        </div>
      </div>
      <div class="row services1-active">

        <!-- 01 -->
        <div v-for="lista in listaProdutos.slice(0, 6)" :key="lista.itiId" class="col-lg-4 col-md-6 col-sm-6">
          <!-- Single -->
          <div class="properties pb-30">
            <div class="properties-card">
              <div class="properties-img">
                <router-link
                  :to="'/ProdutoDetalhe/' + lista.itiId + '/' + formataLink(lista.itiNome + lista.itiReferencia)">
                  <img :src="$imgURL + lista.insInstitucionalImagens[0].itgUrlImagem" alt="">
                </router-link>
              </div>
              <div class="wrap-wrapper">
                <div class="properties-caption">
                  <h3 style="font-size: 21px;font-weight: 700;margin-bottom: 10px;">
                    <router-link
                      :to="'/ProdutoDetalhe/' + lista.itiId + '/' + formataLink(lista.itiNome + lista.itiReferencia)">{{
                        lista.itiNome }}</router-link>
                  </h3>
                  <p v-html="lista.itiResumo1"></p>
                </div>
                <div class="properties-footer d-flex justify-content-between align-items-center">
                  <div class="class-day">
                    <router-link
                      :to="'/ProdutoDetalhe/' + lista.itiId + '/' + formataLink(lista.itiNome + lista.itiReferencia)"
                      class="btn">Mais Detalhes</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- fim nossas linhas -->

  <!--=== parcerias ==========-->
  <div v-if="parcerias != ''" class="support-company-area section-padding-par" v-show="false">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-xl-5 col-lg-5 col-md-10">
          <div class="support-location-img">
            <img :src="$imgURL + parcerias[0].insInstitucionalImagens[0].itgUrlImagem" alt=""
              style="border-radius: 5px;">
          </div>
        </div>
        <div class="col-xl-7 col-lg-7 col-md-10">
          <div class="right-caption">
            <!-- Section Tittle -->
            <div class="section-tittle">
              <h2>{{ parcerias[0].itiNome }}</h2>
            </div>
            <div class="support-caption">
              <p class="mb-10">{{ parcerias[0].itiReferencia }}</p>
              <p v-html="parcerias[0].itiResumo1" class="pera-top"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- final parcerias -->

  <!--=== video ==========-->
  <div v-if="videoItem && (
    (videoItem.insInstitucionalArquivos && videoItem.insInstitucionalArquivos.length > 0) ||
    (videoItem.itiReferencia && videoItem.itiReferencia !== '')
  )" class="services-area1">
    <div class="container">

      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-sm-11">
          <div class="section-tittle text-center">
            <h2>{{ videoItem.itiNome }}</h2>
          </div>
        </div>
      </div>

      <div class="video-gallery-wrap">
        <div class="video-gallery-grid">

          <!-- PERSONAGEM -->
          <div v-if="
            videoItem.insInstitucionalImagens &&
            videoItem.insInstitucionalImagens.length > 0
          " class="video-image-card">
            <img :src="$imgURL + videoItem.insInstitucionalImagens[0].itgUrlImagem" alt="" />
          </div>

          <!-- CAPA DO VÍDEO -->
          <div class="video-cover-card" @click="abrirVideo">
            <!-- PRIMEIRA FOTO = CAPA DO VÍDEO -->
            <img v-if="
              fotosHomeOrdenadas &&
              fotosHomeOrdenadas.length > 0 " :src="$imgURL + fotosHomeOrdenadas[0].itgUrlImagem" alt="Assistir vídeo"
              class="video-cover-image" />

            <!-- PELÍCULA + PLAY -->
            <div class="video-cover-overlay">

              <button type="button" class="video-play-button" aria-label="Assistir vídeo">
                <span>▶</span>
              </button>

              <div class="video-cover-text">
                Assistir vídeo
              </div>

            </div>
          </div>
          <!-- GALERIA -->
          <div class="video-gallery-card">

            <div v-if="
              fotosHomeOrdenadas &&
              fotosHomeOrdenadas.length > 1 " class="video-gallery-grid-images">

              <div v-for="foto in fotosHomeOrdenadas.slice(1, 7)" :key="foto.itgId"
                class="video-gallery-item" style="border: 1px solid #ffffff;">
                <a :href="fotosHome[0].itiNome" target="_blank">
                   <img :src="$imgURL + foto.itgUrlImagem" alt="" />
                </a>
              </div>

            </div>

          </div>

        </div>
      </div>

    </div>

    <!-- MODAL -->
    <v-dialog v-model="modalVideo" max-width="1000">

      <v-card class="video-modal-card">

        <button type="button" class="video-modal-close" @click="fecharVideo">
          ×
        </button>

        <!-- VÍDEO MP4 -->
        <div v-if="
          videoItem.insInstitucionalArquivos &&
          videoItem.insInstitucionalArquivos.length > 0
        " class="video-modal-player">

          <video v-if="modalVideo" controls autoplay class="video-modal-content">
            <source :src="$imgURL + videoItem.insInstitucionalArquivos[0].iagUrlArquivo" type="video/mp4" />
          </video>

        </div>

        <!-- YOUTUBE -->
        <div v-else-if="videoItem.itiReferencia" class="video-modal-player">

          <iframe v-if="modalVideo" :src="videoYoutubeUrl" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen class="video-modal-content"></iframe>

        </div>

      </v-card>

    </v-dialog>

  </div>
  <!-- fim video -->

  <PageCallAction></PageCallAction>

  <!--=== noticias ==========-->
  <section v-if="listaBlog.length > 0" class="blog_area section-padding" v-show="false">
    <div class="container">
      <div class="row">

        <article v-for="noticia in listaBlog.slice(0, 3)" :key="noticia.itiId" class="col-lg-4 blog_item">
          <div class="blog_item_img">
            <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
              class="d-inline-block">
              <img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" class="card-img rounded-0"
                alt=""></router-link>
            <div class="blog_item_date text-center">
              <h3>{{ formattedDateDia(noticia.itiData1) }}</h3>
              <p>{{ formattedDateMes(noticia.itiData1) }}</p>
            </div>
          </div>
          <div class="blog_details">
            <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
              class="d-inline-block">
              <h2 class="blog-head">{{ noticia.itiNome }}
              </h2>
            </router-link>
            <p>{{ resumoCurto(noticia.itiResumo1) }}</p>
            <p><strong><router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)">Leia
                  mais</router-link></strong></p>
          </div>
        </article>

      </div>
    </div>
  </section>
  <!-- final noticias -->


  <!--=== numeros ==========-->
  <div v-if="numeros != ''" class="count-down-area pt-25 section-img-bg2" style="border-bottom: 10px solid #cccccc;">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12 col-md-12">
          <div class="count-down-wrapper">
            <div class="row justify-content-between">
              <div v-for="itemNumero in numeros" :key="itemNumero.itiId" class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-counter d-flex align-items-center">
                  <div class="counter-img">
                    <img :src="$imgURL + itemNumero.insInstitucionalImagens[0].itgUrlImagem" alt="">
                  </div>
                  <div class="captions">
                    <VueJsCounter :start="0" :end="itemNumero.itiReferencia" :duration="7000" class="counter" /><span
                      class="plus">{{ itemNumero.itiCampoExtra1 }}</span>
                    <p class="color-green">{{ itemNumero.itiNome }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- final numeros -->

</template>

<script>
import PageSlider from '../components/PageSlider.vue';
import PageCallAction from '../components/PageCallAction.vue';
import { useHead } from '@vueuse/head';
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'HomeView',
  components: {
    PageSlider,
    PageCallAction,
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    listaProdutos: [],
    parcerias: [],
    video: [],
    fotosHome: [],
    numeros: [],
    listaBlog: [],
    modalVideo: false,
  }),

computed: {

  primeiraNoticia() {
    return this.listaBlog.length > 0
      ? [this.listaBlog[0]]
      : [];
  },

  videoItem() {
    return this.video && this.video.length > 0
      ? this.video[0]
      : null;
  },

  fotosHomeOrdenadas() {
    if (
      !this.fotosHome ||
      this.fotosHome.length === 0 ||
      !this.fotosHome[0].insInstitucionalImagens
    ) {
      return [];
    }

    return [...this.fotosHome[0].insInstitucionalImagens]
      .sort((a, b) => Number(a.itgOrdem) - Number(b.itgOrdem));
  },

  videoYoutubeUrl() {
    if (
      !this.videoItem ||
      !this.videoItem.itiReferencia
    ) {
      return '';
    }

    let referencia = this.videoItem.itiReferencia;

    if (referencia.includes('youtube.com/embed/')) {
      return referencia +
        (referencia.includes('?')
          ? '&autoplay=1'
          : '?autoplay=1');
    }

    if (referencia.includes('youtube.com/watch')) {
      try {
        const url = new URL(referencia);
        const id = url.searchParams.get('v');

        if (id) {
          return `https://www.youtube.com/embed/${id}?autoplay=1`;
        }
      } catch (e) {
        console.error('URL do YouTube inválida', e);
      }
    }

    if (referencia.includes('youtu.be/')) {
      try {
        const url = new URL(referencia);
        const id = url.pathname.replace('/', '');

        if (id) {
          return `https://www.youtube.com/embed/${id}?autoplay=1`;
        }
      } catch (e) {
        console.error('URL do YouTube inválida', e);
      }
    }

    if (!referencia.includes('http')) {
      return `https://www.youtube.com/embed/${referencia}?autoplay=1`;
    }

    return referencia;
  }

},

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    /* data */
    formattedDateDia(value) {
      return this.$moment(value).format('DD')
    },
    formattedDateMes(value) {
      const mes = this.$moment(value).format('MM')
      return mes.charAt(0).toUpperCase() + mes.slice(1)
    },

    /* resumo curto da primeira noticia */
    resumoCurto(conteudo) {
      const textoLimpo = this.removerTagsHTML(conteudo);
      const limite = 200; // você pode ajustar esse número
      return textoLimpo.length > limite ? textoLimpo.slice(0, limite) + '...' : textoLimpo;
    },
    filtraNoticia(categoria) {
      let _filtro = this.listaNoticias.filter(x => x.itiReferencia == categoria);
      this.firstNoticia = _filtro[0];
      this.otherNoticas = _filtro.slice(1, 6);
      this.finalNoticias = _filtro.slice(7);
    },

    carregaMetas(texto) {
      useHead({
        title: 'Igor Paper - Home',
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
    abrirVideo() {
      this.modalVideo = true;
    },

    fecharVideo() {
      this.modalVideo = false;
    },
  },

  created() {
    this.carregaMetas("A Igor Paper uma empresa que une o melhor da tecnologia a um atendimento humanizado. Investimos em inovação para aprimorar continuamente nossos processos, garantindo eficiência e produtos de alto padrão.");

    // lista produtos
    axios.get('/Process/InsInstitucional/institucional/39/listaprodutos/0/x')
      .then(response => {
        this.listaProdutos = response.data.filter(x => x.itiVisivel && x.itiDestaque).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaProdutos')
        //console.log(this.listaProdutos)
      })
      .catch(error => {
        console.error(error);
      });

    // parcerias
    axios.get('/Process/InsInstitucional/institucional/13/parcerias/0/x')
      .then(response => {
        this.parcerias = response.data;
        //console.log('parcerias')
        //console.log(this.parcerias)
      })
      .catch(error => {
        console.error(error);
      });

    // video
    axios.get('/Process/InsInstitucional/institucional/36/video/0/x')
      .then(response => {
        this.video = response.data;
        console.log('video')
        console.log(this.video)
      })
      .catch(error => {
        console.error(error);
      });

    // fotos home
    axios.get('/Process/InsInstitucional/institucional/52/fotosHome/0/x')
      .then(response => {
        this.fotosHome = response.data;
        console.log('fotosHome')
        console.log(this.fotosHome)
      })
      .catch(error => {
        console.error(error);
      });



    // numeros
    axios.get('/Process/InsInstitucional/institucional/47/homenumeros/0/x')
      .then(response => {
        this.numeros = response.data.filter(x => x.itiVisivel);
        //console.log('numeros')
        //console.log(this.numeros)
      })
      .catch(error => {
        console.error(error);
      });


    // notícias da home
    axios.get('/Process/InsInstitucional/institucional/46/listablog/0/itiData1')
      .then(response => {
        this.listaBlog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const timeA = a.itiData1
            ? new Date(a.itiData1).getTime()
            : 0;
          const timeB = b.itiData1
            ? new Date(b.itiData1).getTime()
            : 0;
          return timeA - timeB;
        }).reverse();
        console.log('noticias da home')
        console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });
  },
}

</script>
<style scoped>
/* =========================================================
   BLOCO PRINCIPAL
========================================================= */

.video-gallery-wrap {
  margin-top: 30px;
  width: 100%;
}


/* =========================================================
   ESTRUTURA GERAL
   26% personagem
   30% vídeo
   44% galeria com 6 fotos
========================================================= */

.video-gallery-grid {
  display: grid;
  grid-template-columns: 26% 30% 44%;

  gap: 0;

  width: 100%;
  height: 420px;

  overflow: hidden;
}


/* =========================================================
   PERSONAGEM
========================================================= */

.video-image-card {
  width: 100%;
  height: 420px;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;

  background: #fff;
}

.video-image-card img {
  width: 100%;
  height: 100%;

  object-fit: contain;

  display: block;
}


/* =========================================================
   CAPA DO VÍDEO
========================================================= */

.video-cover-card {
  position: relative;

  width: 100%;
  height: 420px;

  overflow: hidden;
  cursor: pointer;

  background: #000;
}


/* IMAGEM DE FUNDO DO VÍDEO */

.video-cover-image {
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  object-fit: cover;

  display: block;

  transition: transform 0.4s ease;
}


/* PELÍCULA SOBRE A IMAGEM */

.video-cover-overlay {
  position: absolute;

  top: 0;
  left: 0;

  z-index: 2;

  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.25);

  transition: background 0.3s ease;
}


/* EFEITO AO PASSAR O MOUSE */

.video-cover-card:hover .video-cover-image {
  transform: scale(1.04);
}

.video-cover-card:hover .video-cover-overlay {
  background: rgba(0, 0, 0, 0.38);
}


/* =========================================================
   BOTÃO PLAY
========================================================= */

.video-play-button {
  width: 72px;
  height: 72px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 0;
  border-radius: 50%;

  background: #fff;
  color: #075aa7;

  font-size: 28px;

  cursor: pointer;

  box-shadow:
    0 6px 22px rgba(0, 0, 0, 0.35);

  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.video-play-button span {
  display: block;
  margin-left: 4px;
}

.video-cover-card:hover .video-play-button {
  transform: scale(1.08);

  box-shadow:
    0 8px 28px rgba(0, 0, 0, 0.45);
}


/* =========================================================
   TEXTO DO VÍDEO
========================================================= */

.video-cover-text {
  margin-top: 14px;

  color: #fff;

  font-size: 18px;
  font-weight: 700;

  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.6);
}

/* =========================================================
   GALERIA COM 6 FOTOS
   3 colunas x 2 linhas
========================================================= */

.video-gallery-card {
  width: 100%;
  height: 420px;

  overflow: hidden;
}

.video-gallery-grid-images {
  display: grid;

  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));

  width: 100%;
  height: 100%;

  gap: 0;
}

.video-gallery-item {
  width: 100%;
  height: 100%;

  overflow: hidden;
}

.video-gallery-item img {
  width: 100%;
  height: 100%;

  object-fit: cover;

  display: block;

  transition: transform 0.35s ease;
}

.video-gallery-item:hover img {
  transform: scale(1.05);
}


/* =========================================================
   MODAL DO VÍDEO
========================================================= */

.video-modal-card {
  position: relative;

  width: 100%;

  overflow: hidden;

  background: #000 !important;

  border-radius: 10px !important;
}


/* =========================================================
   ÁREA DO PLAYER
========================================================= */

.video-modal-player {
  position: relative;

  width: 100%;

  aspect-ratio: 16 / 9;

  background: #000;
}

.video-modal-content {
  width: 100%;
  height: 100%;

  display: block;

  border: 0;
}


/* =========================================================
   BOTÃO FECHAR MODAL
========================================================= */

.video-modal-close {
  position: absolute;

  top: 10px;
  right: 12px;

  z-index: 20;

  width: 42px;
  height: 42px;

  border: 0;
  border-radius: 50%;

  background: rgba(0, 0, 0, 0.65);

  color: #fff;

  font-size: 30px;
  line-height: 36px;

  cursor: pointer;

  transition: background 0.2s ease;
}

.video-modal-close:hover {
  background: rgba(0, 0, 0, 0.9);
}


/* =========================================================
   TABLET
========================================================= */

@media (max-width: 991px) {

  .video-gallery-grid {
    grid-template-columns: 1fr;
    height: auto;
  }

  .video-image-card {
    height: 350px;
  }

  .video-image-card img {
    object-fit: contain;
  }

  .video-cover-card {
    height: 320px;
  }

  .video-gallery-card {
    height: auto;
  }

  .video-gallery-grid-images {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 180px);

    height: auto;
  }

}


/* =========================================================
   MOBILE
========================================================= */

@media (max-width: 575px) {

  .video-gallery-wrap {
    margin-top: 20px;
  }

  .video-image-card {
    height: 280px;
  }

  .video-cover-card {
    height: 250px;
  }

  .video-play-button {
    width: 62px;
    height: 62px;

    font-size: 24px;
  }

  .video-cover-text {
    margin-top: 12px;

    font-size: 16px;
  }

  .video-gallery-grid-images {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 160px);
  }

}


/* =========================================================
   MOBILE PEQUENO
========================================================= */

@media (max-width: 380px) {

  .video-image-card {
    height: 250px;
  }

  .video-cover-card {
    height: 220px;
  }

  .video-gallery-grid-images {
    grid-template-rows: repeat(3, 140px);
  }

}
</style>